import { useEffect } from 'react';
import AddCandidatesPanel from './AddCandidatesPanel/AddCandidatesPanel';
import ChangesMaybeLostDialog from './Components/ChangesMaybeLostDialog';
import PreviewInvitationEmailDialog from './Components/PreviewInvitationEmailDialog';
import { InviteCandidateProvider } from './Contexts/InviteCandidateContext';
import InvitationLinkPanel from './InvitationLinkPanel/InvitationLinkPanel';

const InviteCandidateContent = () => {
    useEffect(() => {
        window.onbeforeunload = (event) => {
            event.preventDefault();
            return '';
        };
        return () => {
            window.onbeforeunload = null;
        };
    }, []);

    return (
        <InviteCandidateProvider>
            <div className="flex flex-col gap-6">
                <InvitationLinkPanel />
                <AddCandidatesPanel />
            </div>
            <PreviewInvitationEmailDialog />
            <ChangesMaybeLostDialog />
        </InviteCandidateProvider>
    );
};

export default InviteCandidateContent;
